export default "__VITE_ASSET__9bf20d27__"